<template>
  <div class="dashboard__card" v-cloak>
    <CardLoading v-if="loaders.agendas"></CardLoading>
    <div class="dashboard__card-content" :class="{ 'loadingBlur': loaders.agendas }">
      <div class="dashboard__card-header">
        <div class="dashboard__card-title">Meeting Agendas</div>
        <div class="dashboard__card-title-icon dashboard__card-title-icon--meeting-agendas"><i class="fa fa-calendar"></i></div>
      </div>
      <div class="row dashboard__card-body">
        <div class="dashboard__grid dash-library__content-container" v-if="agendas">
          <div class="col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered">
            <div class="dash-library__list">
              <MeetingAgenda v-for="(agenda, index) in cardAgendas" :key="index" :agenda="agenda"></MeetingAgenda>
            </div>
          </div>
        </div>
        <div class="dashboard__grid dashboard__alert alert alert-warning" v-else>
          <div class="dashboard__no-data">No meeting agendas available</div>
        </div>
      </div>
      <div class="dashboard__card-footer">
        <div class="dashboard__card-link" v-if="cardAgendas">
          <router-link to="/meeting-agendas" class="dashboard__card-link-text">View All</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import CardLoading from './CardLoading.vue';
  import MeetingAgenda from '../meeting-agendas/MeetingAgenda.vue';

  export default {
    name: 'MeetingAgendaCard',
    components: {
      CardLoading,
      MeetingAgenda,
    },
    computed: {
      ...mapGetters('meetingAgendas', ['loaders', 'agendas', 'upcomingAgendas']),
      cardAgendas() {
        return lodash.take(this.agendas, 5);
      }
    },
    mounted() {
      this.$store.dispatch('meetingAgendas/getAgendas');
    },
  };
</script>
